<template>
  <header class="sticky">
    <nav class="navbar navbar-expand-lg navbar-light" style="padding-top: 5px; padding-left: 10px;">
      <div class="navbar-container d-flex align-items-center justify-content-between w-100" style="padding-left: 0;">
        <router-link class="navbar-brand m-0 p-0" :to="{name: 'HomePage'}" replace style="position: fixed; top: 16px; left: 20px; z-index: 1050; text-decoration: none;">
          <span class="stella-logo-text" style="font-size: 24px;">✨ stella✦</span>
        </router-link>

        <div style="position: fixed; top: 16px; right: 20px; z-index: 1050;">
          <a class="login-btn" style="cursor: pointer;" @click.prevent="login">Login</a>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
import {httpMixin} from "@/mixin/http-mixin";
import {mapActions} from "vuex";
export default {
  name: "FrontHeader",
  mixins: [httpMixin],
  data() {
    return {
      showSlideBar: false,
      STELLA_URL: process.env.VUE_APP_STELLA_URL
    }
  },
  methods: {
    ...mapActions(['setAgentName']),
    login() {
      this.$router.push({name: 'LoginMobile'});
    },

    isAgency(name) {
      let agencyName = this.$route.params.agencyName;
      return agencyName && agencyName.toLowerCase() === name;
    },

    signUp() {
      this.setAgentName(this.$route.params.agencyName);
      this.$router.push({name: 'CreateAccountMobile'})
    },

    about() {
      this.$router.push({name: 'AboutPage'})
    },

    blog() {
      window.open('https://blog.stella.so', '_blank', 'noopener,noreferrer');
    },
    goTo() {
      window.location = this.STELLA_URL;
    }
  },
}
</script>

<style scoped>
.btn-gradient{
  background-image: -webkit-linear-gradient(90deg, #DE8371 0%, #C56FD1 25.31%, #2F4FE9 74.27%, #56A0CB 100%)!important;
  background-image:    -moz-linear-gradient(90deg, #DE8371 0%, #C56FD1 25.31%, #2F4FE9 74.27%, #56A0CB 100%)!important;
  background-image:     -ms-linear-gradient(90deg, #DE8371 0%, #C56FD1 25.31%, #2F4FE9 74.27%, #56A0CB 100%)!important;
  background-image:      -o-linear-gradient(90deg, #DE8371 0%, #C56FD1 25.31%, #2F4FE9 74.27%, #56A0CB 100%)!important;
  background-image:         linear-gradient(90deg, #DE8371 0%, #C56FD1 25.31%, #2F4FE9 74.27%, #56A0CB 100%)!important;
  background-size: 104%;
  background-position-x: -4px;
}

</style>
